.startPageLists {
    display: flex;
    flex-direction: column;
    gap: var(--bi-scale-5x);
}
